import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionDocumentationWorkflowStateView } from "./EditionDocumentationWorkflowStateView";
import { EditionDocumentationWorkflowStateViewStore } from "../../store/EditionDocumentationWorkflowStateViewStore";
import { useStore } from "../../../../hooks";

export const EditionDocumentationWorkflowStateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/editionDocumentationWorkflowState/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionDocumentationWorkflowStateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionDocumentationWorkflowStateView
          editionDocumentationWorkflowStateViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
